import React from 'react';
import PropTypes from 'prop-types';

/**
 * requires google adsense script loaded in a document
 */
export default class GoogleAd extends React.Component {
    static defaultProps = {
        style: {display: 'block'}
    }

    render() {
        return (
            <ins className="adsbygoogle"
                 style={this.props.style}
                 data-ad-client={this.props.client}
                 data-ad-slot={this.props.slot}/>
        );
    }

    static propTypes = {
        style: PropTypes.object,
        client: PropTypes.string.isRequired,
        slot: PropTypes.string.isRequired,
    };

    componentDidMount() {
        if (window) (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
}